import { Link } from "react-router-dom";
import PublicLayout from "@/components/PublicLayout";
import { CheckCircle2, FileText, Search, Bell } from "lucide-react";

export default function CandidatesLanding() {
  const feats = [
    { icon: FileText, t: "Industry-Specific Profile", d: "Showcase your cable products, conductor types, technical processes and testing expertise." },
    { icon: Search, t: "Get Discovered", d: "Recruiters search by XLPE, HT cable, CV line, stranding — the exact skills you have." },
    { icon: Bell, t: "Job Alerts & Matching", d: "Receive jobs matched to your experience, skills and location preferences." },
  ];
  return (
    <PublicLayout>
      <section className="bg-slate-900 text-white hero-grid">
        <div className="max-w-5xl mx-auto px-6 py-20 text-center">
          <h1 className="font-display text-4xl sm:text-5xl font-extrabold">Your cable industry career, accelerated</h1>
          <p className="mt-4 text-slate-300 max-w-2xl mx-auto">Create a specialized technical profile that gets you in front of India's top cable & conductor manufacturers.</p>
          <Link to="/login?role=candidate" data-testid="candidate-register-btn" className="inline-block mt-8 copper-gradient font-semibold px-8 py-3.5 rounded-lg hover:opacity-95 transition-opacity">Create Your Profile — Free</Link>
        </div>
      </section>
      <section className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-3 gap-6">
        {feats.map((f) => (
          <div key={f.t} className="bg-white p-7 rounded-xl border border-slate-200">
            <div className="w-11 h-11 rounded-lg bg-[#FFF3EC] flex items-center justify-center mb-4"><f.icon className="w-5 h-5 text-[#D96B27]" /></div>
            <h3 className="font-display font-semibold text-lg text-slate-900">{f.t}</h3>
            <p className="text-sm text-slate-500 mt-2">{f.d}</p>
          </div>
        ))}
      </section>
      <section className="max-w-3xl mx-auto px-6 pb-20">
        <div className="bg-white rounded-xl border border-slate-200 p-8">
          <h3 className="font-display font-bold text-xl text-slate-900 mb-4">What you can do</h3>
          <ul className="space-y-3">
            {["Upload resume (PDF/DOC/DOCX) with AI auto-fill", "Add products, conductors, processes, skills & certifications", "Track applications through every stage", "Save jobs & control profile visibility"].map((x) => (
              <li key={x} className="flex items-start gap-3 text-slate-700"><CheckCircle2 className="w-5 h-5 text-emerald-600 shrink-0 mt-0.5" />{x}</li>
            ))}
          </ul>
        </div>
      </section>
    </PublicLayout>
  );
}
